module.exports = __webpack_public_path__ + "img/lobby.282a08dd.svg";